import script from "./PitchforkTool.vue?vue&type=script&lang=js"
export * from "./PitchforkTool.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__